/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import datApi from '../services/dat';
import CopyableText from '../components/CopyableText';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AdminLogoutButton from '../components/AdminLogoutButton';

function StudentPage() {
  const params = new URLSearchParams(window.location.search);
  const [name, setName] = useState(params.get('name') || '');
  const [loading, setLoading] = useState(false);
  const [calculating, setCalculating] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [drivingClass, setDrivingClass] = useState('');
  const [colDefs] = useState([
    {
      headerName: 'STT',
      valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
      width: 80,
      pinned: 'left', // Cố định cột STT bên trái
    },
    {
      field: 'Chi tiết',
      headerName: 'Phiên học',
      cellRenderer: (params) => {
        const onClick = () => {
          window.open(
            `${window.location.origin}/admin/session?name=${params.data['Mã đăng ký']}`,
            '_blank'
          );
        };
        return (
          <Button
            size='sm'
            variant='primary'
            onClick={onClick}
            className='w-100'
          >
            Xem
          </Button>
        );
      },
      width: 100,
    },
    { field: 'Họ và tên', headerName: 'Tên học viên', flex: 1, minWidth: 300, cellRenderer: (p) => <CopyableText value={p.value} /> },
    {
      field: 'total_distance',
      headerName: 'Tổng QĐ',
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        return params.value ? `${Math.floor(params.value * 100) / 100} km` : '';
      },
    },
    {
      field: 'first_checked',
      headerName: 'Kiểm lần 1',
      flex: 1,
      minWidth: 100,
      editable: true,
      valueGetter: (params) => {
        return params.data?.first_checked === true
          ? true
          : params.data?.first_checked === false
          ? false
          : null;
      },
      cellRenderer: 'agCheckboxCellRenderer',
    },
    {
      field: 'second_checked',
      headerName: 'Kiểm lần 2',
      flex: 1,
      minWidth: 100,
      editable: true,
      valueGetter: (params) => {
        return params.data?.second_checked === true
          ? true
          : params.data?.second_checked === false
          ? false
          : null;
      },
      cellRenderer: 'agCheckboxCellRenderer',
    },
    {
      field: 'latest_start_time',
      headerName: 'Phiên học gần nhất',
      valueFormatter: (params) => {
        return params.value
          ? new Date(params.value).toLocaleString('vi-VN', {
              timeZone: 'Asia/Ho_Chi_Minh',
            })
          : '';
      },
      flex: 1,
      minWidth: 200,
      editable: true,
    },
    { field: 'Khóa', headerName: 'Khóa', flex: 1, minWidth: 80 },
    { field: 'Mã đăng ký', headerName: 'Mã học viên', minWidth: 150, flex: 1, cellRenderer: (p) => <CopyableText value={p.value} /> },
    { field: 'Ngày sinh', headerName: 'Ngày sinh', minWidth: 150, flex: 1 },
    {
      field: 'Số CMND/ HC',
      headerName: 'Số CMND/CCCD/HC',
      valueFormatter: (params) => {
        return params.value ? params.value.toString() : '';
      },
      minWidth: 150,
      flex: 1,
    },
  ]);
  const [rowData, setRowData] = useState([]);

  const searchDatData = async (q) => {
    setLoading(true);
    try {
      const data = await datApi.searchStudent(q);
      setRowData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (!name) {
      alert('Vui lòng nhập tên cần tra cứu');
      return;
    }

    let normalizedName = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    normalizedName = normalizedName.replace(/[đĐ]/g, (m) =>
      m === 'đ' ? 'd' : 'D'
    );

    searchDatData({
      name: normalizedName,
      ...(drivingClass && { drivingClass }),
    });
  };

  const calcTotalDistance = async () => {
    setCalculating(true);
    try {
      const data = await datApi.calcTotalDistance();
      setRowData(data);
      toast.success('Tính tổng thành công');
    } catch (error) {
      console.error(error);
    } finally {
      setCalculating(false);
    }
  }

  const searchFirstCheckStudent = async () => {
    setLoading(true);
    try {
      const data = await datApi.searchFirstCheckStudent();
      setRowData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const searchSecondCheckStudent = async () => {
    setLoading(true);
    try {
      const data = await datApi.searchSecondCheckStudent();
      setRowData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const syncStudent = async () => {
    setSyncing(true);
    try {
      await datApi.syncStudent();
      toast.success('Đồng bộ thành công');
    } catch (error) {
      console.error(error);
    } finally {
      setSyncing(false);
    }
  }

  const onCellValueChanged = (params) => {
    const { data, api } = params;

    if (data.first_checked === false && data.second_checked === true) {
      data.first_checked = true;
      api.applyTransaction({ update: [data] });
    }

    const body = {
      'Mã đăng ký': data['Mã đăng ký'],
      first_checked: data.first_checked,
      second_checked: data.second_checked
    };

    datApi.updateStudent(body)
      .then(() => {
        toast('Cập nhật thành công', { type: 'success' });
      })
      .catch(() => {
        toast('Cập nhật thất bại', { type: 'error' });
      });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = 'Tra cứu học viên DAT';

    if (name) {
      searchDatData({
        name: name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        ...(drivingClass && { drivingClass }),
      });
    }
  }
  , [name]);

  return (
    <Container
      style={{
        height: '100vh',
      }}
      fluid
    >
      <Row style={{ height: '10%' }} className='align-items-center position-relative'>
        <h2 className='text-center mb-0'>TRA CỨU HỌC VIÊN DAT</h2>
        <div className='position-absolute end-0 top-50 translate-middle-y' style={{ width: 'auto' }}>
          <AdminLogoutButton />
        </div>
      </Row>
      <Row style={{ height: '15%' }} className='align-items-center'>
        <Col xs={3}>
          <Form.Control
            className='mb-3'
            type='text'
            placeholder='Nhập tên cần tra cứu'
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </Col>

        <Col>
          <Form.Control
            className='mb-3'
            type='text'
            placeholder='Hạng xe'
            value={drivingClass}
            onChange={(e) => setDrivingClass(e.target.value)}
          />
        </Col>

        <Col>
          <Button onClick={handleSearch} variant='primary' disabled={loading} className='w-100 mb-3'>
            Tra cứu
          </Button>
        </Col>
        <Col>
          <Button onClick={syncStudent} variant='primary' disabled={syncing} className='w-100 mb-3'>
            Đồng bộ học viên
          </Button>
        </Col>
        <Col>
          <Button onClick={calcTotalDistance} variant='primary' disabled={calculating} className='w-100 mb-3'>
            Tính tổng
          </Button>
        </Col>
        <Col>
          <Button onClick={searchFirstCheckStudent} variant='primary' disabled={loading} className='w-100 mb-3'>
            Kiểm lần 1
          </Button>
        </Col>
        <Col>
          <Button onClick={searchSecondCheckStudent} variant='primary' disabled={loading} className='w-100 mb-3'>
            Kiểm lần 2
          </Button>
        </Col>
      </Row>
      {loading ? (
        <p className='text-center'>Đang tìm kiếm...</p>
      ) : (
        <div className='ag-theme-quartz' style={{ height: '75%' }}>
          {rowData.length ? (
            <AgGridReact
              rowData={rowData}
              columnDefs={colDefs}
              onCellValueChanged={onCellValueChanged}
            />
          ) : (
            <p className='text-center'>Không có dữ liệu</p>
          )}
        </div>
      )}
    </Container>
  );
}

export default StudentPage;
